import React from "react";
import { useHomeV2Context } from "../context/home_v2_context";
import { Heart, Check, ArrowRight, Play, ChevronDown } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { SignUpRoute } from "../../../../../core/routes/route_constants";
import { useState } from "react";

const HeroComp = () => {
  const {
    companions,
    activeCompanion,
    setActiveCompanion,
    setStartExperienceModalOpen,
    setVideoModalOpen,
    handleModeSelection, // Ensure this function is destructured from the context
  } = useHomeV2Context();

  const [onVideoHover, setOnVideoHover] = useState(false);

  const navigate = useNavigate();

  const onBeginFantasy = () => {
    //setStartExperienceModalOpen(true)
    navigate(SignUpRoute);
  };

  return (
    <div className="max-sm:max-h-dvh flex flex-col items-center py-8 px-4 max-sm:py-3 max-sm:min-h-auto">
      <div className="w-10 h-10 sm:w-14 sm:h-14 mx-auto bg-gradient-to-r from-red-700 via-red-800 to-red-950 rounded-full flex items-center justify-center mb-3 relative">
        <div className="absolute inset-0 rounded-full bg-slate-950 m-0.5 flex items-center justify-center">
          <Heart size={16} className="text-pink-400 animate-pulse-soft" />
        </div>
      </div>

      <div className="text-center mb-3 max-w-4xl relative">
        <h1 className="text-4xl md:text-5xl font-bold mb-2 transition-all duration-500">
          Meet <span className="italic font-serif shimmer-effect pr-1">{companions[activeCompanion].name}</span>
        </h1>
        <p className="text-base md:text-lg text-pink-300 leading-relaxed transition-all duration-500 px-2">
          Beyond simulation: {companions[activeCompanion].description}
        </p>
        {companions.length > 1 && (
          <div className="flex flex-wrap justify-center mt-4 gap-2 max-w-xs mx-auto">
            {companions.map((companion, index) => (
              <button
                key={index}
                className={`w-2.5 h-2.5 sm:w-2 sm:h-2 rounded-full transition-all hover:opacity-100 ${
                  index === activeCompanion ? "bg-pink-500 w-5 sm:w-4 opacity-100" : "bg-pink-500/30 opacity-70 hover:bg-pink-500/50"
                }`}
                onClick={() => setActiveCompanion(index)}
                title={companion.name}
              />
            ))}
          </div>
        )}
      </div>

      {/* <div className="flex flex-col mb-8 space-y-3 max-w-lg md:hidden">
        <div className="flex items-center">
          <div className="w-6 h-6 rounded-full bg-red-900/30 flex items-center justify-center mr-3">
            <Check size={14} className="text-pink-400" />
          </div>
          <span className="text-sm text-pink-200 text-lg">Remembers every conversation and detail about you</span>
        </div>
        <div className="flex items-center">
          <div className="w-6 h-6 rounded-full bg-red-900/30 flex items-center justify-center mr-3">
            <Check size={14} className="text-pink-400" />
          </div>
          <span className="text-sm text-pink-200 text-lg">Evolves from first meeting to deep connection</span>
        </div>
        <div className="flex items-center">
          <div className="w-6 h-6 rounded-full bg-red-900/30 flex items-center justify-center mr-3">
            <Check size={14} className="text-pink-400" />
          </div>
          <span className="text-sm text-pink-200 text-lg">Responds to your emotions in real-time video</span>
        </div>
      </div> */}

      <div className="w-full max-w-xs mb-2 max-sm:mb-6">
        <button
          className="w-full px-6 py-2.5 bg-gradient-to-r from-red-800 via-red-900 to-red-950 rounded-full text-base font-medium btn-hover-effect shadow-lg shadow-red-900/20"
          onClick={onBeginFantasy}
        >
          <span className="flex items-center justify-center">
            <span className="text-sm sm:text-base">Begin Your Fantasy</span>
            <ArrowRight size={16} className="ml-2" />
          </span>
        </button>
        <p className="mt-1 text-center text-pink-400/80 text-[10px] flex items-center justify-center gap-1.5">
          <span>No credit card required</span>
          <span className="w-0.5 h-0.5 bg-pink-500 rounded-full"></span>
          <span className="bg-gradient-to-r from-red-900/50 to-pink-900/50 px-1.5 py-0.5 rounded-full font-medium">Free Trial</span>
        </p>
      </div>

      {/* Video Section */}
      <div
        className="flex flex-col justify-center items-center w-full max-w-xxl cursor-pointer"
        onMouseEnter={() => setOnVideoHover(true)}
        onMouseLeave={() => setOnVideoHover(false)}
        onClick={() => {
          setVideoModalOpen(true);
          handleModeSelection("companion");
        }}
      >
        <div className="h-3" />
        <div className=" overflow-hidden relative rounded-2xl bg-gradient-to-r from-red-700 to-red-800 animate-glow items-center justify-center">
          <div className="rounded-2xl min-h-[10rem] sm:min-h-[20rem] bg-slate-950 shadow-xl shadow-red-900/10">
            <img
              src={"https://storage.googleapis.com/ai-companion-81b04.firebasestorage.app/avatar/eve/eve-highlight.png"}
              alt="Eve"
              className="w-[35rem] h-auto object-cover rounded-2xl"
            />
            {/* <video
              className="w-[43rem] h-auto object-cover rounded-2xl"
              loop
              muted
              playsInline
              onLoadedMetadata={(e) => {
                e.target.currentTime = 28; // Start at 5 seconds
              }}
            >
              <source src={companions[activeCompanion].videoListening} type="video/mp4" />
              Your browser does not support the video tag.
            </video> */}
          </div>
          <div
            className={`rounded-b-2xl absolute bottom-0 left-0 right-0 p-4 flex flex-col items-center justify-center gap-2 duration-300 bg-gradient-to-t from-black/50 to-transparent`}
            onClick={(e) => {
              e.stopPropagation(); // Prevent double triggering
              setVideoModalOpen(true);
              handleModeSelection("companion");
            }}
          >
            <p className="text-white text-lg sm:text-xl font-medium cursor-pointer">Eve has a message for you</p>
            <div className="flex items-center gap-2 text-pink-300 text-sm sm:text-base hover:text-pink-200 transition-colors cursor-pointer">
              <span>Click here to listen</span>
              <Play size={14} className="text-pink-300" />
            </div>
          </div>
        </div>

        {companions.length > 1 && (
          <div className="mt-0 text-center text-xs text-pink-400/70 sm:hidden">
            <span className="flex items-center justify-center">
              <ChevronDown className="-rotate-90 mr-1" size={12} />
              <span>Swipe to explore companions</span>
              <ChevronDown className="rotate-90 ml-1" size={12} />
            </span>
          </div>
        )}

        {companions.length > 1 && (
          <>
            <button
              className="absolute top-1/2 left-0 -ml-2 sm:-ml-4 transform -translate-y-1/2 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gradient-to-r from-red-800 to-red-900 flex items-center justify-center text-white shadow-lg z-30 opacity-70 hover:opacity-100 transition-opacity"
              onClick={(e) => {
                e.stopPropagation();
                setActiveCompanion((prev) => (prev === 0 ? companions.length - 1 : prev - 1));
              }}
            >
              <ChevronDown className="rotate-90" size={16} />
            </button>

            <button
              className="absolute top-1/2 right-0 -mr-2 sm:-mr-4 transform -translate-y-1/2 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gradient-to-r from-red-800 to-red-900 flex items-center justify-center text-white shadow-lg z-30 opacity-70 hover:opacity-100 transition-opacity"
              onClick={(e) => {
                e.stopPropagation();
                setActiveCompanion((prev) => (prev + 1) % companions.length);
              }}
            >
              <ChevronDown className="-rotate-90" size={16} />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default HeroComp;
